module.exports = __webpack_public_path__ + "img/meet.cdf2791b.png";